<div class="home-container">
  <header class="home-hero">
    <h1 class="home-hero-title">Black-box encryption in seconds</h1>
    <p class="home-hero-lead">
      Secure your data stream in seconds. Keep your keys out of the system and away from AI eyes
    </p>
    <app-apply-for-beta></app-apply-for-beta>
  </header>

  <section class="pitch-video" aria-label="Hebern pitch video">
    <div class="pitch-video-inner">
      <h2 class="pitch-video-title">See Hebern in action</h2>
      <div class="pitch-video-frame" #pitchVideoHost>
        @if (pitchVideoSrc(); as src) {
          <video
            #pitchVideo
            class="pitch-video-player"
            controls
            autoplay
            muted
            playsinline
            preload="auto"
            [muted]="true"
            [attr.muted]="''"
            [src]="src"
            (loadeddata)="playPitchVideo($event)"
            (canplay)="playPitchVideo($event)"
          >
            Your browser does not support this video.
          </video>
        } @else {
          <div class="pitch-video-placeholder" aria-hidden="true"></div>
        }
      </div>
    </div>
  </section>

  <!-- Static Pitch Deck Component -->
  <app-pitch-deck-static></app-pitch-deck-static>

  <div class="home-content">
    <!-- Footer Message -->
    <div class="footer-message">
      <p>Questions? We're here to help. Reach out to us anytime.</p>
      <p class="email-link">
        <a href="mailto:support@hebern.com">support@hebern.com</a>
      </p>
    </div>
  </div>
</div>
